import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Leaf, Instagram, Twitter, Linkedin, Facebook, MapPin, Phone, Mail, ChevronRight } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#050505] pt-24 pb-12 px-6 border-t border-white/5 relative overflow-hidden">
      {/* Background Glow */}
      <div className="absolute bottom-0 right-0 w-[40%] h-[40%] bg-primary/5 blur-[120px] -z-10 rounded-full"></div>

      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-16 mb-24">
          
          {/* Company Info */}
          <div className="space-y-8 col-span-1 lg:col-span-1 text-left">
            <Link 
              to="/" 
              className="inline-block"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <img src="/logo.png" alt="AgniThrust Logo" className="w-auto h-[60px]" />
            </Link>
            <p className="text-slate-400 font-medium leading-relaxed max-w-sm">
              AgniThrust Private Ltd: Leading the way in sustainable energy solutions. We produce high-quality biomass pellets and bio coal for a greener tomorrow.
            </p>
            <div className="flex items-center gap-4">
               {[Instagram, Twitter, Linkedin, Facebook].map((Icon, idx) => (
                 <motion.a
                   key={idx}
                   href="#"
                   whileHover={{ scale: 1.1, y: -2 }}
                   className="w-10 h-10 glass rounded-xl flex items-center justify-center text-slate-400 hover:text-primary transition-colors border border-white/5"
                 >
                   <Icon size={18} />
                 </motion.a>
               ))}
            </div>
          </div>

          {/* Useful Links */}
          <div className="lg:pl-12 text-left">
            <h4 className="text-lg font-black syne mb-8 tracking-wide">Quick Links</h4>
            <ul className="space-y-4">
              {[
                { name: 'About Us', href: '/about' },
                { name: 'Our Products', href: '/products' },
                { name: 'Contact Info', href: '/contact' },
                { name: 'Sustainability', href: '#' }
              ].map(link => (
                <li key={link.name}>
                  <Link to={link.href} className="flex items-center gap-2 text-slate-400 hover:text-primary transition-colors group">
                    <ChevronRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-black syne mb-8 tracking-wide">Get In Touch</h4>
            <div className="space-y-6">
               <div className="flex items-start gap-4 text-slate-400">
                  <MapPin className="text-primary mt-1 shrink-0" size={20} />
                  <p className="font-medium text-sm leading-relaxed">
                     A-4 Ramji Industry, Nava Gam,<br />Near Pasodra, Surat, Gujarat 394185
                  </p>
               </div>
               <div className="flex items-center gap-4 text-slate-400">
                  <Phone className="text-primary shrink-0" size={18} />
                  <p className="font-medium text-sm">+91 76218 46829</p>
               </div>
               <div className="flex items-center gap-4 text-slate-400">
                  <Mail className="text-primary shrink-0" size={18} />
                  <p className="font-medium text-sm">info@agnithrust.com</p>
               </div>
            </div>
          </div>

          {/* Newsletter */}
          <div className="space-y-6">
            <h4 className="text-lg font-black syne mb-2 tracking-wide">Stay Updated</h4>
            <p className="text-slate-400 text-sm font-medium">Subscribe to our newsletter for latest green tech updates.</p>
            <div className="relative group">
               <input 
                 type="email" 
                 placeholder="your@email.com" 
                 className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 text-sm focus:outline-none focus:border-primary/50 focus:ring-1 focus:ring-primary/20 transition-all font-medium"
               />
               <button className="absolute right-2 top-2 bottom-2 bg-primary hover:bg-primary-light text-white px-5 rounded-xl font-bold text-xs ring-4 ring-black shadow-lg transition-colors">
                  JOIN
               </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-slate-500 text-xs font-bold uppercase tracking-widest">
            © 2026 BioEnergy Solutions. All Rights Reserved.
          </p>
          <div className="flex gap-8 text-[10px] font-black uppercase text-slate-400 tracking-[0.2em]">
             <a href="#" className="hover:text-primary transition-colors">Privacy Policy</a>
             <a href="#" className="hover:text-primary transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
